import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpirePageComponentSize} from '../umpire-page-component-size';
import {UmpireOttPlaylist} from '../umpire-ott-playlist';
import {UmpireImageOrientation} from '../umpire-image-orientation';
import {UmpireOttEvent} from '../umpire-ott-event';

export interface UmpireComponentOttPlaylist
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_PLAYLIST> {
  playlist: UmpireOttPlaylist;
  size: UmpirePageComponentSize;
  is_featured: boolean;
  image_orientation: UmpireImageOrientation;
  name: string;
  events?: UmpireOttEvent[];
}
